import { render, staticRenderFns } from "./RowBlockRefundFundsTestContract.vue?vue&type=template&id=0ba7f366&"
import script from "./RowBlockRefundFundsTestContract.vue?vue&type=script&lang=js&"
export * from "./RowBlockRefundFundsTestContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports